var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { useState } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { Button, ButtonContainer, Modal, ModalHeader, Typography } from '@emburse/ui-core';
import { Select } from '@ReactComponents/Select';
import { LinkedAccountsApiService } from '@ClientApi/linkedAccounts';
export const AddUserConnectedSubaccountModal = ({ linkedAccountId, closeModal, users, onCardAdded }) => {
    const [selectedIds, setSelectedIds] = React.useState([]);
    const [loading, setLoading] = useState(false);
    const usersOptions = users.map((user) => {
        return {
            value: user.id,
            label: user.name || user.email
        };
    });
    function addCards() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                setLoading(true);
                yield LinkedAccountsApiService.addCards(linkedAccountId, { user_ids: selectedIds });
                toast.success('Cards added');
                onCardAdded();
            }
            catch (err) {
                toast.error(err.message);
            }
            finally {
                setLoading(false);
                closeModal();
            }
        });
    }
    function modalHeader() {
        return _jsx(ModalHeader, { title: 'Add Subaccount Cards', onCloseClicked: () => closeModal() });
    }
    return (_jsxs(Modal, Object.assign({ open: true, onClose: () => closeModal(), modalHeader: modalHeader(), isLoading: loading }, { children: [_jsx(Typography, Object.assign({ gutterBottom: true, variant: 'h6' }, { children: "Select the team members who have corporate cards" })), _jsx(Select, { isMulti: true, options: usersOptions, value: usersOptions.filter((option) => selectedIds.indexOf(option.value) > -1), onChange: (values) => setSelectedIds(values.map((option) => option.value)) }), _jsxs(Typography, Object.assign({ gutterBottom: true }, { children: ["They will be prompted to connect their cards to ", window.whitelabelConfiguration.tags.brandName, ". You can always add more team members later."] })), _jsxs(ButtonContainer, Object.assign({ alignButtons: 'right', style: { marginTop: 30 } }, { children: [_jsx(Button, Object.assign({ primary: true, variant: "outlined", onClick: closeModal }, { children: "Cancel" })), _jsx(Button, Object.assign({ primary: true, onClick: addCards, disabled: selectedIds.length === 0 }, { children: "Add Cards" }))] }))] })));
};
const mapStateToProps = (state, ownProps) => (Object.assign(Object.assign({}, ownProps), { users: state.users.usersActiveOrInvited }));
export const AddUserConnectedSubaccountModalConnected = connect(mapStateToProps, {})(AddUserConnectedSubaccountModal);
